import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ILPDistribution } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import { colors } from '../../const'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getLPDistributionConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_lp_distribution', timeframe)) as ILPDistribution[]
	const series1 = chartData.map((element: ILPDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.LESS_THAN_100_COUNT }
	})
	const series2 = chartData.map((element: ILPDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.LESS_THAN_1K_MORE_THAN_100_COUNT }
	})
	const series3 = chartData.map((element: ILPDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.LESS_THAN_5K_MORE_THAN_1K_COUNT }
	})
	const series4 = chartData.map((element: ILPDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.LESS_THAN_10K_MORE_THAN_5K_COUNT }
	})
	const series5 = chartData.map((element: ILPDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.LESS_THAN_50K_MORE_THAN_10K_COUNT }
	})
	const series6 = chartData.map((element: ILPDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.LESS_THAN_100K_MORE_THAN_50K_COUNT }
	})
	const series7 = chartData.map((element: ILPDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.MORE_THAN_100K_COUNT }
	})

	const config: IChart[] = [
		{
			data: series7,
			strokeWidth: 2,
			name: 'lp count (100k$, inf)',
			type: 'bars',
			seriesGroup: '[liq provider #]',
			color: `${colors[0]}`,
			barGroup: 'stacked'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'lp count (50k$, 100k$⟩',
			type: 'bars',
			seriesGroup: '[liq provider #]',
			color: `${colors[1]}`,
			barGroup: 'stacked'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'lp count (10k$, 50k$⟩',
			type: 'bars',
			seriesGroup: '[liq provider #]',
			color: `${colors[2]}`,
			barGroup: 'stacked'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'lp count (5k$, 10k$⟩',
			type: 'bars',
			seriesGroup: '[liq provider #]',
			color: `${colors[3]}`,
			barGroup: 'stacked'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'lp count (1k$, 5k$⟩',
			type: 'bars',
			seriesGroup: '[liq provider #]',
			color: `${colors[4]}`,
			barGroup: 'stacked'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'lp count (100$, 1k$⟩',
			type: 'bars',
			seriesGroup: '[liq provider #]',
			color: `${colors[5]}`,
			barGroup: 'stacked'
		},
		{
			data: series1,
			strokeWidth: 2,
			name: 'lp count (0 ,100$⟩',
			type: 'bars',
			seriesGroup: '[liq provider #]',
			color: `${colors[6]}`,
			barGroup: 'stacked'
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const LPDistribution = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getLPDistributionConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	if (dataSeries !== undefined) {
		return (
			<ChartPage
				chartTitle="Liquidity Provider Distribution"
				chartDesc="Number of liquidity providers grouped by the size of their positions (value brackets). Reveals concentration among small vs large LPs."
				chartDescTitle="Metric Description"
				chartData={dataSeries.config}
				queryId="52325cf6-1f1d-4e8f-854c-cdbc50c9aff4"
				timeframe={timeframe}
				setTimeframe={setTimeframe}
				hasHours={false}
				reverseLegend={true}
			/>
		)
	}
}

export default LPDistribution
